export const POLYGON_TYPES = {
  PATH: "path",
  PATH_BUFFER: "path_buffer",
  STOP: "stop",
  DEFAULT: "defailt",
};
